'use client';

import {useEffect, useState} from 'react';
import {useDebouncedFunction} from './useDebouncedFunction';

export function useDebouncedValue<T>(value: T, timeout = 300): T {
	const [state, setState] = useState(value);
	const debouncedSetState = useDebouncedFunction(setState, timeout);

	useEffect(() => {
		debouncedSetState(value);
	}, [value, debouncedSetState]);

	return state;
}
